import { render } from "./CBankSelect.vue?vue&type=template&id=37da0bf0"
import script from "./CBankSelect.vue?vue&type=script&lang=js"
export * from "./CBankSelect.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__